import * as CONFIG from "../../../config";

export const cnp_sso_path = CONFIG.APP_CONFIG.CNP_V1_SSO_API_GATEWAY;
export const headers = {
  Accept: "*/*",
  "Content-Type": "application/json; charset=utf-8",
  "Access-Control-Allow-Origin": "*",
};
